export default __webpack_public_path__ + "static/media/qrcode-site-1024w.b9870884.png";